export const awardType = {
  grant: 'Grant',
  contract: 'Contract'
}

export const subjectType = {
  business: 'Business',
  individual: 'Individual',
  singleIndividual: 'SingleIndividual'
}
